// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import  improvementActivitiesContainerView  from '../../../../templates/MIPS/Dashboard/improvementActivitiesContainerView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

    initialize: function() {
        this.channel = Backbone.Radio.channel( 'AppChannel' );
        this.app = this.channel.request( 'app' );
        this.listenTo( this.model, `
            change:dashboardData
            change:exclusions
        `, this.render );
    },

    getTemplate: function() {
        return improvementActivitiesContainerView( this.model );
    },

});
